/**
 * The four store-required pages live at skiffs.app since SK-189, so these are
 * ABSOLUTE links off this host rather than react-router <Link>s. A <Link> here
 * would push a client-side route that no longer exists and land on the SPA 404
 * — a broken footer on the one host every share link points at.
 */
export function Footer() {
  const MARKETING_ORIGIN = 'https://skiffs.app';

  return (
    <footer className="skf-footer">
      <span>© {new Date().getFullYear()} Skiffs</span>
      <nav aria-label="Site links">
        <a href={`${MARKETING_ORIGIN}/privacy`}>Privacy</a>
        {' · '}
        <a href={`${MARKETING_ORIGIN}/terms`}>Terms</a>
        {' · '}
        <a href={`${MARKETING_ORIGIN}/support`}>Support</a>
      </nav>
    </footer>
  );
}
